// Generated by `yarn tokens:import --aos-ds` from the Figma component set "Chip/Severity" (9321:187313). Do not edit.
//
// The "state" axis is interaction state, so it is not a prop: hover and hovered are `hover:`, pressed is `active:`, focus is `focus:`,
// and disabled is applied in JS because react-native-web renders a div, which
// Tailwind's `disabled:` never matches.

import type { FigmaGlyph } from '../../icons/glyph'

export type ContractProp =
    | { kind: 'enum'; values: readonly string[] }
    | { kind: 'boolean' }
    | { kind: 'text' }
    | { kind: 'instance_swap' }
    // A matrix can carry slots too — Modal/Footer has two.
    | { kind: 'slot' }

export type ContractComposition = { component: string; variants: readonly string[] }

// A place the Figma file contradicts itself, grouped by what it says. `count` is
// how many places say it; `property` and `stated` are set for an alignment the
// file states and does not draw.
export type ContractDisagreement = {
    note: string
    count: number
    property?: string
    stated?: string
}

export type ContractVariant = {
    container: string
    label: string
    // The surface, when the paint sits on a child rather than the root:
    // empty for every component that paints its own frame.
    box: string
    // Every named node the variant draws beyond those two, keyed by the
    // name Figma gives it. A key that reads as a value rather than a role
    // means the component is a composition, not a primitive.
    parts: Record<string, string>
    // The shape of every part that is one — a VECTOR drawn on top of
    // something the variant also paints, which the whole-variant `glyph`
    // cannot describe because that one requires no paint at all.
    glyphs: Record<string, FigmaGlyph>
    // The glyph the variant draws, inked separately from the label.
    icon: string
    // Applied in JS: `disabled:` never matches a react-native-web div, and
    // `:visited` exists only on an anchor.
    disabled: string
    visited: string
    // Which of `textStyleIds` each text part is set in. The ids are a set,
    // so a component with two says two exist and not which part uses which.
    partTextStyles: Record<string, string>
    // What this cell instantiates, and which variant of it.
    composes: readonly ContractComposition[]
}

export const chipSeverityContract = {
    component: 'Chip/Severity',
    nodeId: '9321:187313',
    section: '[Web] Primitives',
    // Components a variant instantiates, with the variant keys used.
    // Where one of these carries the component's own paint rather than
    // a glyph, the classes below describe only what is left — Checkbox
    // swaps a whole box here.
    composes: [
        {
            component: 'SeverityItem',
            variants: [
                'variant=caution, size=big',
                'variant=critical, size=big',
                'variant=info, size=big',
                'variant=neutral, size=big',
                'variant=success, size=big',
                'variant=warning, size=big',
            ],
        },
    ],
    stateAxis: 'state',
    // Where the caller puts content. One `ReactNode` prop per name.
    slots: [] as readonly string[],
    // What the file says that its own drawing does not show.
    disagreeing: [] as readonly ContractDisagreement[],
    textStyleIds: ['S:ab7c4fdfb951974b07e9f2c1fced98aecc30762c,'],
    props: {
        selected: { kind: 'boolean' },
        tone: {
            kind: 'enum',
            values: ['maintenance', 'normal', 'moderate', 'major', 'crisis', 'neutral'],
        },
    },
    variants: {
        'selected=false, tone=crisis': {
            container:
                'bg-background-highlight border-border-subtle border rounded-common pl-s pr-m gap-s h-[2.5rem] min-h-[2.5rem] items-center hover:bg-background-highlight-hover hover:border-border-strong',
            label: 'text-content-default text-left',
            icon: 'text-status-critical',
            disabled: 'opacity-disabled',
            visited: '',
            box: '',
            parts: {
                'option-label': 'text-content-default text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                'option-label': 'S:ab7c4fdfb951974b07e9f2c1fced98aecc30762c,',
            } as Record<string, string>,
            composes: [{ component: 'SeverityItem', variants: ['variant=critical, size=big'] }],
        },
        'selected=false, tone=maintenance': {
            container:
                'bg-background-highlight border-border-subtle border rounded-common pl-s pr-m gap-s h-[2.5rem] min-h-[2.5rem] items-center hover:bg-background-highlight-hover hover:border-border-strong',
            label: 'text-content-default text-left',
            icon: 'text-status-neutral',
            disabled: 'opacity-disabled',
            visited: '',
            box: '',
            parts: {
                'option-label': 'text-content-default text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                'option-label': 'S:ab7c4fdfb951974b07e9f2c1fced98aecc30762c,',
            } as Record<string, string>,
            composes: [{ component: 'SeverityItem', variants: ['variant=neutral, size=big'] }],
        },
        'selected=false, tone=major': {
            container:
                'bg-background-highlight border-border-subtle border rounded-common pl-s pr-m gap-s h-[2.5rem] min-h-[2.5rem] items-center hover:bg-background-highlight-hover hover:border-border-strong',
            label: 'text-content-default text-left',
            icon: 'text-status-caution',
            disabled: 'opacity-disabled',
            visited: '',
            box: '',
            parts: {
                'option-label': 'text-content-default text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                'option-label': 'S:ab7c4fdfb951974b07e9f2c1fced98aecc30762c,',
            } as Record<string, string>,
            composes: [{ component: 'SeverityItem', variants: ['variant=caution, size=big'] }],
        },
        'selected=false, tone=moderate': {
            container:
                'bg-background-highlight border-border-subtle border rounded-common pl-s pr-m gap-s h-[2.5rem] min-h-[2.5rem] items-center hover:bg-background-highlight-hover hover:border-border-strong',
            label: 'text-content-default text-left',
            icon: 'text-status-warning',
            disabled: 'opacity-disabled',
            visited: '',
            box: '',
            parts: {
                'option-label': 'text-content-default text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                'option-label': 'S:ab7c4fdfb951974b07e9f2c1fced98aecc30762c,',
            } as Record<string, string>,
            composes: [{ component: 'SeverityItem', variants: ['variant=warning, size=big'] }],
        },
        'selected=false, tone=neutral': {
            container:
                'bg-background-highlight border-border-subtle border rounded-common pl-s pr-m gap-s h-[2.5rem] min-h-[2.5rem] items-center hover:bg-background-highlight-hover hover:border-border-strong',
            label: 'text-content-default text-left',
            icon: 'text-status-info',
            disabled: 'opacity-disabled',
            visited: '',
            box: '',
            parts: {
                'option-label': 'text-content-default text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                'option-label': 'S:ab7c4fdfb951974b07e9f2c1fced98aecc30762c,',
            } as Record<string, string>,
            composes: [{ component: 'SeverityItem', variants: ['variant=info, size=big'] }],
        },
        'selected=false, tone=normal': {
            container:
                'bg-background-highlight border-border-subtle border rounded-common pl-s pr-m gap-s h-[2.5rem] min-h-[2.5rem] items-center hover:bg-background-highlight-hover hover:border-border-strong',
            label: 'text-content-default text-left',
            icon: 'text-status-success',
            disabled: 'opacity-disabled',
            visited: '',
            box: '',
            parts: {
                'option-label': 'text-content-default text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                'option-label': 'S:ab7c4fdfb951974b07e9f2c1fced98aecc30762c,',
            } as Record<string, string>,
            composes: [{ component: 'SeverityItem', variants: ['variant=success, size=big'] }],
        },
        'selected=true, tone=crisis': {
            container:
                'bg-background-highlight border-status-critical border-2 rounded-common pl-s pr-m gap-s h-[2.5rem] min-h-[2.5rem] items-center',
            label: 'text-content-default text-left',
            icon: 'text-status-critical',
            disabled: 'opacity-disabled border',
            visited: '',
            box: '',
            parts: {
                'option-label': 'text-content-default text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                'option-label': 'S:ab7c4fdfb951974b07e9f2c1fced98aecc30762c,',
            } as Record<string, string>,
            composes: [{ component: 'SeverityItem', variants: ['variant=critical, size=big'] }],
        },
        'selected=true, tone=maintenance': {
            container:
                'bg-background-highlight border-status-neutral border-2 rounded-common pl-s pr-m gap-s h-[2.5rem] min-h-[2.5rem] items-center',
            label: 'text-content-default text-left',
            icon: 'text-status-neutral',
            disabled: 'opacity-disabled border',
            visited: '',
            box: '',
            parts: {
                'option-label': 'text-content-default text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                'option-label': 'S:ab7c4fdfb951974b07e9f2c1fced98aecc30762c,',
            } as Record<string, string>,
            composes: [{ component: 'SeverityItem', variants: ['variant=neutral, size=big'] }],
        },
        'selected=true, tone=major': {
            container:
                'bg-background-highlight border-status-caution border-2 rounded-common pl-s pr-m gap-s h-[2.5rem] min-h-[2.5rem] items-center',
            label: 'text-content-default text-left',
            icon: 'text-status-caution',
            disabled: 'opacity-disabled border',
            visited: '',
            box: '',
            parts: {
                'option-label': 'text-content-default text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                'option-label': 'S:ab7c4fdfb951974b07e9f2c1fced98aecc30762c,',
            } as Record<string, string>,
            composes: [{ component: 'SeverityItem', variants: ['variant=caution, size=big'] }],
        },
        'selected=true, tone=moderate': {
            container:
                'bg-background-highlight border-status-warning border-2 rounded-common pl-s pr-m gap-s h-[2.5rem] min-h-[2.5rem] items-center',
            label: 'text-content-default text-left',
            icon: 'text-status-warning',
            disabled: 'opacity-disabled border',
            visited: '',
            box: '',
            parts: {
                'option-label': 'text-content-default text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                'option-label': 'S:ab7c4fdfb951974b07e9f2c1fced98aecc30762c,',
            } as Record<string, string>,
            composes: [{ component: 'SeverityItem', variants: ['variant=warning, size=big'] }],
        },
        'selected=true, tone=neutral': {
            container:
                'bg-background-highlight border-status-info border-2 rounded-common pl-s pr-m gap-s h-[2.5rem] min-h-[2.5rem] items-center',
            label: 'text-content-default text-left',
            icon: 'text-status-info',
            disabled: 'opacity-disabled border',
            visited: '',
            box: '',
            parts: {
                'option-label': 'text-content-default text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                'option-label': 'S:ab7c4fdfb951974b07e9f2c1fced98aecc30762c,',
            } as Record<string, string>,
            composes: [{ component: 'SeverityItem', variants: ['variant=info, size=big'] }],
        },
        'selected=true, tone=normal': {
            container:
                'bg-background-highlight border-status-success border-2 rounded-common pl-s pr-m gap-s h-[2.5rem] min-h-[2.5rem] items-center',
            label: 'text-content-default text-left',
            icon: 'text-status-success',
            disabled: 'opacity-disabled border',
            visited: '',
            box: '',
            parts: {
                'option-label': 'text-content-default text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                'option-label': 'S:ab7c4fdfb951974b07e9f2c1fced98aecc30762c,',
            } as Record<string, string>,
            composes: [{ component: 'SeverityItem', variants: ['variant=success, size=big'] }],
        },
    },
} as const satisfies {
    component: string
    nodeId: string
    section: string
    composes: readonly ContractComposition[]
    stateAxis: string | null
    slots: readonly string[]
    disagreeing: readonly ContractDisagreement[]
    textStyleIds: readonly string[]
    props: Record<string, ContractProp>
    variants: Record<string, ContractVariant>
}
